import {
  EventResult,
  EventResultEnum,
  isEventResultError,
} from '@/features/events/types/EventResult.ts';
import Typography from '@mui/material/Typography';
import { Trans } from '@lingui/react/macro';

export interface FormattedEventResultProps {
  result: EventResult;
}

export const FormattedEventResult = ({ result }: FormattedEventResultProps) => {
  if (result === EventResultEnum.E_USER_ABORTED) {
    return (
      <Typography color="success" variant="inherit" component="span">
        <Trans>Aborted</Trans>
      </Typography>
    );
  }

  if (result === EventResultEnum.E_OK) {
    return (
      <Typography color="success" variant="inherit" component="span">
        <Trans>OK</Trans>
      </Typography>
    );
  }

  if (isEventResultError(result)) {
    return (
      <Typography color="error" variant="inherit" component="span">
        <Trans>Error</Trans> ({result})
      </Typography>
    );
  }

  return (
    <Typography color="textSecondary" variant="inherit" component="span">
      <Trans>Unknown</Trans>
    </Typography>
  );
};
